import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import axios from "axios";
import jwtDecode from "jwt-decode";
import React, { Component } from "react";
//Redux
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Analytics from "react-router-ga"; // workaround so that we don't have to change BrowserRouter to Router
import "./App.css";
//Components
import Navbar from "./components/Navbar";
import curriculum from "./pages/curriculum";
import editProfile from "./pages/editProfile";
import kadagroup from "./pages/kadagroup";
import landing from "./pages/landing";
import login from "./pages/login";
import milestone from "./pages/milestone";
import notifications from "./pages/notifications";
import profile from "./pages/profile";
import programs from "./pages/programs";
import progress from "./pages/progress";
import autopilotusers from "./pages/autopilotusers";
import signup from "./pages/signup";
import syllabus from "./pages/syllabus";
import { getUserData, logoutUser } from "./redux/actions/userActions";
import store from "./redux/store";
import { SET_AUTHENTICATED } from "./redux/types";
//Tracking
import { initGA } from "./tracking";
import AuthRoute from "./util/AuthRoute";
import ProtectedRoute from "./util/ProtectedRoute";



const token = localStorage.FBIdToken;
if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(logoutUser());
    window.location.href = "/login";
  } else {
    store.dispatch({
      type: SET_AUTHENTICATED,
      payload: { source: "Existing", userId: decodedToken.user_id },
    });
    axios.defaults.headers.common["Authorization"] = token;
    store.dispatch(getUserData());
  }
}

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#63a3e5",
      main: "#2a6196",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: "#e9a746",
      main: "#df8146",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#ffffff",
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: "'Avenir', 'Helvetica', 'Arial', sans-serif;",
    h3: {
      margin: "10px auto 10px auto",
      fontFamily: "'Avenir', 'Helvetica', 'Arial', sans-serif;",
      fontSize: "2em",
      fontWeight: "700",
      textAlign: "left",
      color: "#2a6196",
    },
    h4: {
      margin: "10px auto 10px auto",
      fontFamily: "'Avenir', 'Helvetica', 'Arial', sans-serif;",
      fontSize: "1.5em",
      fontWeight: "700",
      textAlign: "left",
      color: "#2a6196",
    },
    h5: {
      margin: "5px auto 5px auto",
      fontFamily: "'Avenir', 'Helvetica', 'Arial', sans-serif;",
      fontSize: "1em",
      fontWeight: "700",
      textAlign: "left",
      color: "#000000",
    },
    body1: {
      fontWeight: "85",
      fontFamily: "'Avenir', 'Helvetica', 'Arial', sans-serif;",
      color: "#747474",
    },
    body2: {
      fontWeight: "85",
      fontFamily: "'Avenir', 'Helvetica', 'Arial', sans-serif;",
      color: "#2a6196",
    },
  },
});

// Google Analytics token
const GA_TOKEN = "UA-179554491-1";

class App extends Component {
  componentDidMount() {
    initGA(GA_TOKEN);
    
    // add fb pixel
    const script = document.createElement("script");
    script.src = "js/fbpixel.js";
    script.async = true;
    document.head.appendChild(script);
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <Router>
            <Navbar />
            <img height="1" width="1" src={"https://www.facebook.com/tr?id=429854284947867&ev=PageView&noscript=1"}/>
            <div className="container">
              <Analytics id={GA_TOKEN} debug>
                <Switch>
                  <AuthRoute exact path="/" component={landing} />
                  <AuthRoute exact path="/login" component={login} />
                  <AuthRoute exact path="/signup" component={signup} />
                  <Route exact path="/programs" component={programs} />
                  <ProtectedRoute exact path="/profile" component={profile} />
                  <ProtectedRoute
                    exact
                    path="/profile/edit"
                    component={editProfile}
                  />
                  {/* Slide 11 to 14 */}
                  <Route
                    exact
                    path="/curriculum/:programId"
                    component={syllabus}
                  />
                  {/* Slide 6 and 10 */}
                  <ProtectedRoute
                    exact
                    path="/curriculum"
                    component={curriculum}
                  />
                  <ProtectedRoute
                    exact
                    path="/notifications"
                    component={notifications}
                  />
                  <Route exact path="/connect" component={kadagroup} />
                  <ProtectedRoute exact path="/progress/:programId" component={progress} />
                  <ProtectedRoute exact path="/autopilotusers" component={autopilotusers} />
                  <ProtectedRoute 
                    exact 
                    path="/milestone" 
                    component={milestone} 
                  />
                </Switch>
              </Analytics>
            </div>
          </Router>
        </Provider>
      </MuiThemeProvider>
    );
  }
}

export default App;
